module.exports = __webpack_public_path__ + "media/images/games/world_culture_awareness/3-c30ffc57bafd2e55c98716bac90f3ec4.png";